import { AbstractCommand } from './AbstractCommand';
import { CommandResponse } from '../types';
import { getSequenceId } from '../utils/sequenceIdManager';

export enum LightEffect {
  ON = 'on',
  OFF = 'off',
  FLASHING = 'flashing'
}

export enum LightNode {
  CHAMBER = 'chamber_light',
  WORK = 'work_light'
}

export interface LightOptions {
  onTime?: number;
  offTime?: number;
  loops?: number;
  interval?: number;
}

export class SetLightCommand extends AbstractCommand {
  public readonly category = 'system';
  public readonly command = 'ledctrl' as const;

  private static readonly DEFAULT_ON_TIME = 500;
  private static readonly DEFAULT_OFF_TIME = 500;
  private static readonly DEFAULT_LOOPS = 1;
  private static readonly DEFAULT_INTERVAL = 1000;

  constructor(params: {
    node: LightNode,
    effect: LightEffect,
    options?: LightOptions
  }) {
    super({
      led_node: params.node,
      led_mode: params.effect,
      led_on_time: params.options?.onTime || SetLightCommand.DEFAULT_ON_TIME,
      led_off_time: params.options?.offTime || SetLightCommand.DEFAULT_OFF_TIME,
      loop_times: params.options?.loops || SetLightCommand.DEFAULT_LOOPS,
      interval_time: params.options?.interval || SetLightCommand.DEFAULT_INTERVAL
    });
  }

  ownsResponse(response: CommandResponse, sequence_id?: string): boolean {
    // Check if it's a system response
    if (!('system' in response)) {
      return false;
    }

    const systemResponse = response as { system: { sequence_id?: string | undefined } };
    const responseId = systemResponse.system?.sequence_id;
    const extraId = this.extra?.sequence_id;

    // Check if sequence_id matches
    if (responseId) {
      if (sequence_id && responseId === sequence_id) {
        return true;
      }

      if (extraId && responseId === extraId) {
        return true;
      }
    }

    // Also check for lights_report in the response (similar to UpdateLightCommand)
    if ('lights_report' in response) {
      return true;
    }

    return false;
  }
}